//#region src/qsr_automations_department_key.ts
var QsrAutomationsDepartmentKey = /* @__PURE__ */ function(QsrAutomationsDepartmentKey) {
	QsrAutomationsDepartmentKey["SectionBiteId"] = "section-bite-id";
	QsrAutomationsDepartmentKey["SectionInternalName"] = "section-internal-name";
	return QsrAutomationsDepartmentKey;
}(QsrAutomationsDepartmentKey || {});
//#endregion
export { QsrAutomationsDepartmentKey };

//# sourceMappingURL=qsr_automations_department_key.js.map